"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMessage = void 0;
/* eslint-disable import/prefer-default-export */
var react_1 = __importDefault(require("react"));
var SendMessage = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24px' : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c;
    return react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: color, d: "M11.5581 4.55806C11.8021 4.31398 12.1979 4.31398 12.4419 4.55806L18.4419 10.5581C18.686 10.8021 18.686 11.1979 18.4419 11.4419C18.1979 11.686 17.8021 11.686 17.5581 11.4419L12.625 6.50888V19C12.625 19.3452 12.3452 19.625 12 19.625C11.6548 19.625 11.375 19.3452 11.375 19V6.50888L6.44194 11.4419C6.19786 11.686 5.80214 11.686 5.55806 11.4419C5.31398 11.1979 5.31398 10.8021 5.55806 10.5581L11.5581 4.55806Z" }));
};
exports.SendMessage = SendMessage;
